import { Button, Stack, Divider, Skeleton } from '@mui/material'

import { type StepKey } from '../AudioPromptWizard'
import { type RepeatAudioStepKey } from '../../RepeatAudioWizard/RepeatAudioWizard'

import { Header, TranscriptPreview } from './common'

import TimeWaveForm from '@/components/TimelineWaveForm'
import { type CardActivity } from '@/models/card-activity/card-activity.model'

function ReviewStep(props: {
  navigateTo: (step: StepKey | RepeatAudioStepKey) => void
  onClose: () => void
  audioData: { url: string; fileName: string }
  transcript: string
  uploadingAudio: boolean
  loadingTranscript: boolean
  setTranscript: (transcript: string | null) => void
  setAudioData: (data: { url: string; fileName: string } | null) => void
  mode: string
  onComplete: (data: Partial<CardActivity>) => void
}) {
  const {
    setAudioData,
    setTranscript,
    onClose,
    onComplete,
    uploadingAudio,
    loadingTranscript,
    transcript,
    navigateTo,
    audioData,
    mode,
  } = props
  const isAddPronunciation = mode === 'add-pronunciation'

  const handleAddPrompt = () => {
    if (isAddPronunciation) {
      onComplete({ audio: audioData })
    } else {
      onComplete({ audio: audioData, prompt: transcript, hidePrompt: true })
    }
    onClose()
  }

  return (
    <Stack
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <Header title={isAddPronunciation ? 'Pronunciation Recorded' : 'Audio Prompt Recorded'} onClose={onClose} />
      <Divider />
      <Stack
        sx={{
          padding: '24px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '10px',
        }}
      >
        {uploadingAudio ? (
          <Skeleton height={40} variant="rounded" width="100%" />
        ) : audioData?.url ? (
          <TimeWaveForm
            containerStyles={{ borderRadius: '16px', background: '#F9FAFB', width: '100%' }}
            src={audioData?.url}
          />
        ) : null}
        {!isAddPronunciation && (
          <>
            {uploadingAudio || loadingTranscript ? (
              <Skeleton sx={{ width: '100%', fontSize: 12 }} variant="text" />
            ) : (
              <TranscriptPreview maxLength={200} navigateTo={navigateTo} transcript={transcript} />
            )}
          </>
        )}
      </Stack>
      <Stack direction="row" gap="10px" justifyContent="flex-end" padding="20px 12px 12px 12px">
        <Button
          disabled={loadingTranscript || uploadingAudio}
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            navigateTo(isAddPronunciation ? 'record-pronunciation' : 'choose')
            setTranscript && setTranscript(null)
            setAudioData(null)
          }}
        >
          Re-record
        </Button>
        <Button
          disabled={loadingTranscript || uploadingAudio}
          variant="contained"
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            handleAddPrompt()
          }}
        >
          {isAddPronunciation ? 'Add Pronunciation' : 'Add to prompt'}
        </Button>
      </Stack>
    </Stack>
  )
}

export default ReviewStep
